import { useEffect, useState } from "react";

export function getSessionOptions(betDirection) {
  const direction = String(betDirection || "both").toLowerCase();
  if (direction === "open") return ["OPEN"];
  if (direction === "close") return ["CLOSE"];
  return ["OPEN", "CLOSE"];
}

export function applySessionToBids(bids, gameType, getKey) {
  const merged = [];
  const indexByKey = new Map();

  bids.forEach((bid) => {
    const key = String(getKey(bid));
    const existingIndex = indexByKey.get(key);
    if (existingIndex == null) {
      indexByKey.set(key, merged.length);
      merged.push({ ...bid, gameType });
      return;
    }
    const existing = merged[existingIndex];
    merged[existingIndex] = {
      ...existing,
      points: (Number(existing.points) || 0) + (Number(bid.points) || 0),
    };
  });

  return merged;
}

export default function MatkaSessionSelect({
  betDirection,
  value,
  onChange,
  variant = "dropdown",
}) {
  const lower = variant === "bulk";
  const options = getSessionOptions(betDirection).map((option) =>
    lower ? option.toLowerCase() : option
  );
  const [internalValue, setInternalValue] = useState(options[0]);
  const isControlled = value !== undefined;
  const currentValue = isControlled ? value : internalValue;
  const selected = options.includes(currentValue) ? currentValue : options[0];

  useEffect(() => {
    if (currentValue === selected) return;
    if (isControlled) {
      onChange?.(selected);
      return;
    }
    setInternalValue(selected);
  }, [currentValue, selected, isControlled, onChange]);

  const handleChange = (nextValue) => {
    if (!isControlled) setInternalValue(nextValue);
    onChange?.(nextValue);
  };

  const boxClass = lower
    ? "matka-panna-bulk-select-box"
    : "matka-game-type-dropdown-box";
  const selectClass = lower
    ? "matka-panna-bulk-select"
    : "matka-game-type-dropdown";
  const arrowClass = lower ? "matka-panna-bulk-arrow" : "matka-dropdown-arrow";

  return (
    <div className={boxClass}>
      <select
        className={selectClass}
        value={selected}
        onChange={(event) => handleChange(event.target.value)}
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      <span className={arrowClass}>▼</span>
    </div>
  );
}
